// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.tournament-inscription__title.baloa-subtitle-2{
    color: var(--primary-very-dark-color);
    padding-bottom: var(--space-and-half);
}

.tournament-inscription__content .baloa-username {
    color: var(--primary-very-dark-color);
    padding-bottom: var(--space-half);
}

.tournament-inscription__content .MuiFormGroup-root{
    flex-wrap: nowrap;
}

.tournament-inscription__content__tree-button.MuiFormControl-root{
    margin-bottom: 16px;
}

/* .MuiFormGroup-root.tournament-inscription__content__option-button{
    padding-bottom: var(--space-and-half);
} */
.tournament-inscription__content__option-button .MuiRadio-root{
    color: var(--new-gray-background-color);
}
.tournament-inscription__content__option-button .MuiFormControlLabel-root{
    border-radius: 13px;
    border: 1px solid var(--new-gray-background-color);
    margin-left: 0;
    min-width: 145px;
}
.tournament-inscription__content__option-button .MuiFormControlLabel-root.selected{
    border: 1px solid var(--new-green-color);
    margin-left: 0;
    min-width: 145px;
}

.tournament-inscription__content__option-button .MuiFormControlLabel-root.MuiFormControlLabel-labelPlacementStart{
    margin: 0;
    padding: var(--space-half-quarter) var(--space);
    margin-right: var(--space);
    justify-content: space-between;
}
.tournament-inscription__content__half-buttons.MuiFormControl-root{
    width: 100%;
    margin-bottom: 24px;
}
.tournament-inscription__content__half-buttons .tournament-inscription__content__option-button .MuiFormControlLabel-root{
    margin: 0;
    width: 50%;
    margin-right: var(--space);
}
.tournament-inscription__content__half-buttons span.baloa-username {
    color: var(--primary-very-dark-color);
    padding: var(--space) 0;
}

.tournament-inscription__content__half-buttons.hidden {
    display: none;
}
.tournament-inscription__content__option-button-label{
    display: flex;
    align-items: center;
    
}
.tournament-inscription__content__option-button-label .icon-email ,
.tournament-inscription__content__option-button-label .icon-group-friends,
.tournament-inscription__content__option-button-label .icon-team,
.tournament-inscription__content__option-button-label .hubicon-money_off,
.tournament-inscription__content__option-button-label .hubicon-paid{
    font-size: 34px;
    color: var(--new-green-color);
    padding-right: var(--space-and-half);
}

.tournament-inscription__content__option-button-label__caption.baloa-username{
    color: var(--basic-gray-color);
    margin-top: 9px;
}

.tournament-inscription__content .input-field {
    padding-right: var(--space);
    padding-bottom: var(--space);
    width: 50%;
    margin: 0;
}
.tournament-inscription__content .input-field-multiline {
    padding-right: var(--space);
    padding-bottom: var(--space);
    margin: 0;
}
.tournament-inscription__content .input-field-input{
    background: #FFFFFF;
    border: 1px solid var(--new-gray-background-color);
    border-radius: 8px;
}

.tournament-inscription__content .input-field-multiline-input{
    background: #FFFFFF;
    border: 1px solid var(--new-gray-background-color);
}

.tournament-inscription__content__double-input{
    display: flex;
    align-items: center;
    padding-bottom: var(--space);
}

.tournament-inscription__content__double-input .disabledMax .input-field-input {
    background-color: var(--new-gray-background-color);
    color: var(--new-gray-background-color);
}

.tournament-inscription__content__group-input{
    width: 50%;
}

.tournament-inscription__container-input{
    display: flex;
    align-items: baseline;
    /* border-radius: 16px;
    background: #FFFFFF;
    color: var(--primary-very-dark-color);*/
} 

.tournament-inscription__input {
    background: #FFFFFF;
    padding: 13px 6px 13px 8px;
    border: 1px solid var(--new-gray-background-color);
    border-radius: 0px 8px 8px 0px;
}
.tournament-inscription__content_registration .input-field{
    padding-right: unset;
}

.tournament-inscription__content__group-input .input-field{
    width: 80%;
}

.one-column{
    width: 50%;
    align-items: center;
    padding-bottom: var(--space);
}

.one-column .input-field {
    width: 30%;
    padding: 0;
}
.MuiFormGroup-root.tournament-inscription__content__option-button.inside {
    padding-bottom: 0;
    min-height: 48px;
}

.tournament-inscription__content__one-button{
    width: 33%;
}
.tournament-inscription__content__one-button .tournament-inscription__content__option-button .MuiFormControlLabel-root{
    margin: 0;
    width: 100%;
    margin-left: var(--space);
}
.tournament-inscription__content__one-button span.baloa-username {
    color: var(--primary-very-dark-color);
    padding: var(--space) 0;
}

.tournament-inscription__content__option-button .MuiFormControlLabel-label.Mui-disabled .baloa-username, 
.tournament-inscription__content__option-button .MuiRadio-colorSecondary.Mui-disabled {
    color: var(--disabled-color);
}

.tournament-inscription__content_registration{
    width: 80%;
}

.tournament-inscription__content_registration input{
    background: #FFFFFF;
    border: 1px solid var(--new-gray-background-color);
    border-radius: 8px;
    padding: var(--space) var(--space-and-half);
    width: 100%;
    font-family: var(--secondary-font);
    font-size: var(--space);
    max-height: var(--space-x3);
}

.tournament-inscription__monetary_prize{
    padding-bottom: var(--space);
}

.tournament-inscription__form-control:active,.tournament-inscription__form-control:focus {
    border: 1px solid var(--new-gray-background-color);
    outline: none;
}

.tournament-inscription__content__button-group button.MuiButtonBase-root.MuiToggleButton-root.MuiToggleButtonGroup-grouped.MuiToggleButtonGroup-groupedHorizontal{
    border-radius: 9px;
    border: 1px solid var(--new-gray-background-color);
    color: var(--primary-dark-color);
}

.tournament-inscription__content__button-group button.MuiButtonBase-root.MuiToggleButton-root.MuiToggleButtonGroup-grouped.MuiToggleButtonGroup-groupedHorizontal:hover{
    background-color: var(--new-green-color);
    color: var(--white-color);
}

.tournament-inscription__content__button-group button.MuiButtonBase-root.MuiToggleButton-root.MuiToggleButtonGroup-grouped.MuiToggleButtonGroup-groupedHorizontal.Mui-selected{
    background-color: var(--new-green-color);
    color: var(--white-color);
}

.tournament-inscription__content__button-group button.MuiButtonBase-root.MuiToggleButton-root.Mui-selected{
    margin-left: 8px;
}


.tournament-inscription__content__button-group span.MuiToggleButton-label {
    text-transform: initial;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    letter-spacing: 0.0025em;
}

.tournament-inscription__content__button-group .MuiToggleButton-root.Mui-selected{
    color: var(--white-color);
    background-color: var(--new-green-color);
}

.tournament-inscription__content__button-group .MuiToggleButton-root {
    border: 1px solid #E7E7E7;
    border-radius: 9px;
    padding: 20px;
    font-size: 0.875rem;
    box-sizing: border-box;
    font-weight: 500;
    line-height: 1.75;
    text-transform: uppercase;
}
.tournament-inscription__content__button-group{
    margin-bottom: var(--space);
}

.tournament-inscription__content__button-group .baloa-names
{
    color: var(--primary-very-dark-color);
}

.tournament-inscription__content__option-button__list.MuiFormGroup-row{
    flex-direction: column;
}

.tournament-inscription__content__option-button__list .MuiTypography-body1 {
    padding-top: 9px;
}

.tournament-inscription__content__option-button__list .MuiTypography-body1 .baloa-table-column{
    color: var(--primary-very-dark-color);
    margin-bottom: 12px;
    font-weight: var(--font-regular);
}

.tournament-inscription__content__option-button__list .MuiTypography-body1 .baloa-username{
    color: var(--basic-gray-color);
}

.tournament-inscription__content__option-button__list .MuiFormControlLabel-root {
    align-items: flex-start;
}

.tournament-inscription__content__process-fee.MuiFormControl-root {
    margin-bottom: 24px;
}

.tournament-inscription__content__payment_settings {
    border: 1px solid var(--new-gray-background-color);
    border-radius: var(--space-half);
    margin-bottom: var(--space-and-half);
}

.tournament-inscription__content__payment_settings__container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    
}

.tournament-inscription__content__payment_settings__button .icon{
    grid-area: icon;
    font-size: 22px;
    margin-right: 4px;
}

.tournament-inscription__content__payment_settings__button:hover .hubicon-settings::before,
.tournament-inscription__content__payment_settings__button:focus .hubicon-settings::before{
    color: var(--white-color);
}

.tournament-inscription__content__payment_settings__saved-config {
    padding: var(--space);
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid var(--new-gray-background-color);
}

.tournament-inscription__content__payment_settings__saved-config__total-fee .baloa-table-column {
    color: var(--primary-dark-color);
    margin-bottom: var(--space-half);
}

.tournament-inscription__content__payment_settings__saved-config__total-fee .baloa-username {
    color: var(--primary-very-dark-color);
}

.tournament-inscription__content__create-form__options-box.active,
.tournament-inscription__content__create-form__options-box__empty.active  {
    display: flex;
    flex-direction: column;
}

.tournament-inscription__content__create-form__options-box {
    position: absolute;
    background: var(--white-color);
    box-shadow: 0px 1px 4px rgb(150 150 150 / 25%);
    width: 280px;
    right: 12px;
    top: 43px;
    display: none;
    border-radius: 8px;
    border: 1px solid var(--new-gray-background-color);
    padding: 8px;
    z-index: 2;
}

.tournament-inscription__content__create-form__options-box__empty {
    position: absolute;
    background: var(--white-color);
    box-shadow: 0px 1px 4px rgb(150 150 150 / 25%);
    width: 280px;
    left: calc(50% - 136px);
    top: 68px;
    display: none;
    border-radius: 8px;
    border: 1px solid var(--new-gray-background-color);
    padding: 8px;
    z-index: 2;
}

.tournament-inscription__content__create-form__options-box__option{
    margin-bottom: 4px;
    padding: var(--space-half);
    border-radius: 8px;
}

.tournament-inscription__content__create-form__options-box__option:hover{
    cursor: pointer;
    background-color: var(--new-background-color);
}

.tournament-inscription__content__form-buttons {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 12px;
}

.tournament-inscription__content__form-buttons.baloa-table {
    color: var(--primary-very-dark-color);
    font-weight: var(--font-medium);
}

.tournament-inscription__content__half-buttons.form-buttons.MuiFormControl-root {
    border: 1px solid var(--new-gray-background-color);
    border-radius: 8px;
    margin-top: 24px;
    margin-bottom: 0;    
}

.tournament-inscription__content__form-buttons .secondary-button:hover .hubicon-settings::before {
    color: var(--white-color);
}

.tournament-inscription__content__form-buttons .button  {
    padding: 8px 6px;
}

.tournament-inscription__content__form-buttons .icon {
    grid-area: icon;
    font-size: 16px;
    margin-right: 2px;
}

.tournament-inscription__content__form-info {
    border-top: 1px solid var(--new-gray-background-color);
    padding: 8px 12px;
    position: relative;
}

.tournament-inscription__content__form-info__empty {
    display: block;
    text-align: center;
    padding: 12px;
}

.tournament-inscription__content__form-info__empty .baloa-table-column{
    color: var(--basic-gray-color);
}

.tournament-inscription__content__form-info__empty .baloa-hyperlink-2{
    color: var(--new-green-color);
    margin-top: 8px;
    cursor: pointer;
}

.tournament-inscription__content__form-info__form-data {
    padding: 12px;
}

.tournament-inscription__content__form-info__empty .baloa-username{
    color: var(--primary-dark-color);
}

.modal-confirm-dialog__actions .button:first-of-type {
    border: none;
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/tournament-inscription/TournamentInscriptionComponent.styles.css"],"names":[],"mappings":";AACA;IACI,qCAAqC;IACrC,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;IACrC,iCAAiC;AACrC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;GAEG;AACH;IACI,uCAAuC;AAC3C;AACA;IACI,mBAAmB;IACnB,kDAAkD;IAClD,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,wCAAwC;IACxC,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,+CAA+C;IAC/C,0BAA0B;IAC1B,8BAA8B;AAClC;AACA;IACI,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,SAAS;IACT,UAAU;IACV,0BAA0B;AAC9B;AACA;IACI,qCAAqC;IACrC,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;AACA;IACI,aAAa;IACb,mBAAmB;;AAEvB;AACA;;;;;IAKI,eAAe;IACf,6BAA6B;IAC7B,oCAAoC;AACxC;;AAEA;IACI,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,2BAA2B;IAC3B,4BAA4B;IAC5B,UAAU;IACV,SAAS;AACb;AACA;IACI,2BAA2B;IAC3B,4BAA4B;IAC5B,SAAS;AACb;AACA;IACI,mBAAmB;IACnB,kDAAkD;IAClD,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,kDAAkD;AACtD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA;IACI,kDAAkD;IAClD,uCAAuC;AAC3C;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB;;2CAEuC;AAC3C;;AAEA;IACI,mBAAmB;IACnB,0BAA0B;IAC1B,kDAAkD;IAClD,8BAA8B;AAClC;AACA;IACI,oBAAoB;AACxB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA;IACI,UAAU;IACV,UAAU;AACd;AACA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;AACA;IACI,SAAS;IACT,WAAW;IACX,yBAAyB;AAC7B;AACA;IACI,qCAAqC;IACrC,uBAAuB;AAC3B;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,kDAAkD;IAClD,kBAAkB;IAClB,2CAA2C;IAC3C,WAAW;IACX,kCAAkC;IAClC,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,kDAAkD;IAClD,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,kDAAkD;IAClD,gCAAgC;AACpC;;AAEA;IACI,wCAAwC;IACxC,yBAAyB;AAC7B;;AAEA;IACI,wCAAwC;IACxC,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;;AAGA;IACI,uBAAuB;IACvB,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;IACzB,wCAAwC;AAC5C;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;AAC7B;AACA;IACI,2BAA2B;AAC/B;;AAEA;;IAEI,qCAAqC;AACzC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,qCAAqC;IACrC,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kDAAkD;IAClD,gCAAgC;IAChC,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,aAAa;;AAEjB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,iBAAiB;AACrB;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,sDAAsD;AAC1D;;AAEA;IACI,gCAAgC;IAChC,gCAAgC;AACpC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;;IAEI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,8BAA8B;IAC9B,8CAA8C;IAC9C,YAAY;IACZ,WAAW;IACX,SAAS;IACT,aAAa;IACb,kBAAkB;IAClB,kDAAkD;IAClD,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,8BAA8B;IAC9B,8CAA8C;IAC9C,YAAY;IACZ,uBAAuB;IACvB,SAAS;IACT,aAAa;IACb,kBAAkB;IAClB,kDAAkD;IAClD,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,6CAA6C;AACjD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;AACrB;;AAEA;IACI,qCAAqC;IACrC,+BAA+B;AACnC;;AAEA;IACI,kDAAkD;IAClD,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,sDAAsD;IACtD,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,6BAA6B;IAC7B,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,YAAY;AAChB","sourcesContent":["\n.tournament-inscription__title.baloa-subtitle-2{\n    color: var(--primary-very-dark-color);\n    padding-bottom: var(--space-and-half);\n}\n\n.tournament-inscription__content .baloa-username {\n    color: var(--primary-very-dark-color);\n    padding-bottom: var(--space-half);\n}\n\n.tournament-inscription__content .MuiFormGroup-root{\n    flex-wrap: nowrap;\n}\n\n.tournament-inscription__content__tree-button.MuiFormControl-root{\n    margin-bottom: 16px;\n}\n\n/* .MuiFormGroup-root.tournament-inscription__content__option-button{\n    padding-bottom: var(--space-and-half);\n} */\n.tournament-inscription__content__option-button .MuiRadio-root{\n    color: var(--new-gray-background-color);\n}\n.tournament-inscription__content__option-button .MuiFormControlLabel-root{\n    border-radius: 13px;\n    border: 1px solid var(--new-gray-background-color);\n    margin-left: 0;\n    min-width: 145px;\n}\n.tournament-inscription__content__option-button .MuiFormControlLabel-root.selected{\n    border: 1px solid var(--new-green-color);\n    margin-left: 0;\n    min-width: 145px;\n}\n\n.tournament-inscription__content__option-button .MuiFormControlLabel-root.MuiFormControlLabel-labelPlacementStart{\n    margin: 0;\n    padding: var(--space-half-quarter) var(--space);\n    margin-right: var(--space);\n    justify-content: space-between;\n}\n.tournament-inscription__content__half-buttons.MuiFormControl-root{\n    width: 100%;\n    margin-bottom: 24px;\n}\n.tournament-inscription__content__half-buttons .tournament-inscription__content__option-button .MuiFormControlLabel-root{\n    margin: 0;\n    width: 50%;\n    margin-right: var(--space);\n}\n.tournament-inscription__content__half-buttons span.baloa-username {\n    color: var(--primary-very-dark-color);\n    padding: var(--space) 0;\n}\n\n.tournament-inscription__content__half-buttons.hidden {\n    display: none;\n}\n.tournament-inscription__content__option-button-label{\n    display: flex;\n    align-items: center;\n    \n}\n.tournament-inscription__content__option-button-label .icon-email ,\n.tournament-inscription__content__option-button-label .icon-group-friends,\n.tournament-inscription__content__option-button-label .icon-team,\n.tournament-inscription__content__option-button-label .hubicon-money_off,\n.tournament-inscription__content__option-button-label .hubicon-paid{\n    font-size: 34px;\n    color: var(--new-green-color);\n    padding-right: var(--space-and-half);\n}\n\n.tournament-inscription__content__option-button-label__caption.baloa-username{\n    color: var(--basic-gray-color);\n    margin-top: 9px;\n}\n\n.tournament-inscription__content .input-field {\n    padding-right: var(--space);\n    padding-bottom: var(--space);\n    width: 50%;\n    margin: 0;\n}\n.tournament-inscription__content .input-field-multiline {\n    padding-right: var(--space);\n    padding-bottom: var(--space);\n    margin: 0;\n}\n.tournament-inscription__content .input-field-input{\n    background: #FFFFFF;\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 8px;\n}\n\n.tournament-inscription__content .input-field-multiline-input{\n    background: #FFFFFF;\n    border: 1px solid var(--new-gray-background-color);\n}\n\n.tournament-inscription__content__double-input{\n    display: flex;\n    align-items: center;\n    padding-bottom: var(--space);\n}\n\n.tournament-inscription__content__double-input .disabledMax .input-field-input {\n    background-color: var(--new-gray-background-color);\n    color: var(--new-gray-background-color);\n}\n\n.tournament-inscription__content__group-input{\n    width: 50%;\n}\n\n.tournament-inscription__container-input{\n    display: flex;\n    align-items: baseline;\n    /* border-radius: 16px;\n    background: #FFFFFF;\n    color: var(--primary-very-dark-color);*/\n} \n\n.tournament-inscription__input {\n    background: #FFFFFF;\n    padding: 13px 6px 13px 8px;\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 0px 8px 8px 0px;\n}\n.tournament-inscription__content_registration .input-field{\n    padding-right: unset;\n}\n\n.tournament-inscription__content__group-input .input-field{\n    width: 80%;\n}\n\n.one-column{\n    width: 50%;\n    align-items: center;\n    padding-bottom: var(--space);\n}\n\n.one-column .input-field {\n    width: 30%;\n    padding: 0;\n}\n.MuiFormGroup-root.tournament-inscription__content__option-button.inside {\n    padding-bottom: 0;\n    min-height: 48px;\n}\n\n.tournament-inscription__content__one-button{\n    width: 33%;\n}\n.tournament-inscription__content__one-button .tournament-inscription__content__option-button .MuiFormControlLabel-root{\n    margin: 0;\n    width: 100%;\n    margin-left: var(--space);\n}\n.tournament-inscription__content__one-button span.baloa-username {\n    color: var(--primary-very-dark-color);\n    padding: var(--space) 0;\n}\n\n.tournament-inscription__content__option-button .MuiFormControlLabel-label.Mui-disabled .baloa-username, \n.tournament-inscription__content__option-button .MuiRadio-colorSecondary.Mui-disabled {\n    color: var(--disabled-color);\n}\n\n.tournament-inscription__content_registration{\n    width: 80%;\n}\n\n.tournament-inscription__content_registration input{\n    background: #FFFFFF;\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 8px;\n    padding: var(--space) var(--space-and-half);\n    width: 100%;\n    font-family: var(--secondary-font);\n    font-size: var(--space);\n    max-height: var(--space-x3);\n}\n\n.tournament-inscription__monetary_prize{\n    padding-bottom: var(--space);\n}\n\n.tournament-inscription__form-control:active,.tournament-inscription__form-control:focus {\n    border: 1px solid var(--new-gray-background-color);\n    outline: none;\n}\n\n.tournament-inscription__content__button-group button.MuiButtonBase-root.MuiToggleButton-root.MuiToggleButtonGroup-grouped.MuiToggleButtonGroup-groupedHorizontal{\n    border-radius: 9px;\n    border: 1px solid var(--new-gray-background-color);\n    color: var(--primary-dark-color);\n}\n\n.tournament-inscription__content__button-group button.MuiButtonBase-root.MuiToggleButton-root.MuiToggleButtonGroup-grouped.MuiToggleButtonGroup-groupedHorizontal:hover{\n    background-color: var(--new-green-color);\n    color: var(--white-color);\n}\n\n.tournament-inscription__content__button-group button.MuiButtonBase-root.MuiToggleButton-root.MuiToggleButtonGroup-grouped.MuiToggleButtonGroup-groupedHorizontal.Mui-selected{\n    background-color: var(--new-green-color);\n    color: var(--white-color);\n}\n\n.tournament-inscription__content__button-group button.MuiButtonBase-root.MuiToggleButton-root.Mui-selected{\n    margin-left: 8px;\n}\n\n\n.tournament-inscription__content__button-group span.MuiToggleButton-label {\n    text-transform: initial;\n    font-family: 'Roboto';\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 0.0025em;\n}\n\n.tournament-inscription__content__button-group .MuiToggleButton-root.Mui-selected{\n    color: var(--white-color);\n    background-color: var(--new-green-color);\n}\n\n.tournament-inscription__content__button-group .MuiToggleButton-root {\n    border: 1px solid #E7E7E7;\n    border-radius: 9px;\n    padding: 20px;\n    font-size: 0.875rem;\n    box-sizing: border-box;\n    font-weight: 500;\n    line-height: 1.75;\n    text-transform: uppercase;\n}\n.tournament-inscription__content__button-group{\n    margin-bottom: var(--space);\n}\n\n.tournament-inscription__content__button-group .baloa-names\n{\n    color: var(--primary-very-dark-color);\n}\n\n.tournament-inscription__content__option-button__list.MuiFormGroup-row{\n    flex-direction: column;\n}\n\n.tournament-inscription__content__option-button__list .MuiTypography-body1 {\n    padding-top: 9px;\n}\n\n.tournament-inscription__content__option-button__list .MuiTypography-body1 .baloa-table-column{\n    color: var(--primary-very-dark-color);\n    margin-bottom: 12px;\n    font-weight: var(--font-regular);\n}\n\n.tournament-inscription__content__option-button__list .MuiTypography-body1 .baloa-username{\n    color: var(--basic-gray-color);\n}\n\n.tournament-inscription__content__option-button__list .MuiFormControlLabel-root {\n    align-items: flex-start;\n}\n\n.tournament-inscription__content__process-fee.MuiFormControl-root {\n    margin-bottom: 24px;\n}\n\n.tournament-inscription__content__payment_settings {\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: var(--space-half);\n    margin-bottom: var(--space-and-half);\n}\n\n.tournament-inscription__content__payment_settings__container {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 16px;\n    \n}\n\n.tournament-inscription__content__payment_settings__button .icon{\n    grid-area: icon;\n    font-size: 22px;\n    margin-right: 4px;\n}\n\n.tournament-inscription__content__payment_settings__button:hover .hubicon-settings::before,\n.tournament-inscription__content__payment_settings__button:focus .hubicon-settings::before{\n    color: var(--white-color);\n}\n\n.tournament-inscription__content__payment_settings__saved-config {\n    padding: var(--space);\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    border-top: 1px solid var(--new-gray-background-color);\n}\n\n.tournament-inscription__content__payment_settings__saved-config__total-fee .baloa-table-column {\n    color: var(--primary-dark-color);\n    margin-bottom: var(--space-half);\n}\n\n.tournament-inscription__content__payment_settings__saved-config__total-fee .baloa-username {\n    color: var(--primary-very-dark-color);\n}\n\n.tournament-inscription__content__create-form__options-box.active,\n.tournament-inscription__content__create-form__options-box__empty.active  {\n    display: flex;\n    flex-direction: column;\n}\n\n.tournament-inscription__content__create-form__options-box {\n    position: absolute;\n    background: var(--white-color);\n    box-shadow: 0px 1px 4px rgb(150 150 150 / 25%);\n    width: 280px;\n    right: 12px;\n    top: 43px;\n    display: none;\n    border-radius: 8px;\n    border: 1px solid var(--new-gray-background-color);\n    padding: 8px;\n    z-index: 2;\n}\n\n.tournament-inscription__content__create-form__options-box__empty {\n    position: absolute;\n    background: var(--white-color);\n    box-shadow: 0px 1px 4px rgb(150 150 150 / 25%);\n    width: 280px;\n    left: calc(50% - 136px);\n    top: 68px;\n    display: none;\n    border-radius: 8px;\n    border: 1px solid var(--new-gray-background-color);\n    padding: 8px;\n    z-index: 2;\n}\n\n.tournament-inscription__content__create-form__options-box__option{\n    margin-bottom: 4px;\n    padding: var(--space-half);\n    border-radius: 8px;\n}\n\n.tournament-inscription__content__create-form__options-box__option:hover{\n    cursor: pointer;\n    background-color: var(--new-background-color);\n}\n\n.tournament-inscription__content__form-buttons {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 8px 12px;\n}\n\n.tournament-inscription__content__form-buttons.baloa-table {\n    color: var(--primary-very-dark-color);\n    font-weight: var(--font-medium);\n}\n\n.tournament-inscription__content__half-buttons.form-buttons.MuiFormControl-root {\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 8px;\n    margin-top: 24px;\n    margin-bottom: 0;    \n}\n\n.tournament-inscription__content__form-buttons .secondary-button:hover .hubicon-settings::before {\n    color: var(--white-color);\n}\n\n.tournament-inscription__content__form-buttons .button  {\n    padding: 8px 6px;\n}\n\n.tournament-inscription__content__form-buttons .icon {\n    grid-area: icon;\n    font-size: 16px;\n    margin-right: 2px;\n}\n\n.tournament-inscription__content__form-info {\n    border-top: 1px solid var(--new-gray-background-color);\n    padding: 8px 12px;\n    position: relative;\n}\n\n.tournament-inscription__content__form-info__empty {\n    display: block;\n    text-align: center;\n    padding: 12px;\n}\n\n.tournament-inscription__content__form-info__empty .baloa-table-column{\n    color: var(--basic-gray-color);\n}\n\n.tournament-inscription__content__form-info__empty .baloa-hyperlink-2{\n    color: var(--new-green-color);\n    margin-top: 8px;\n    cursor: pointer;\n}\n\n.tournament-inscription__content__form-info__form-data {\n    padding: 12px;\n}\n\n.tournament-inscription__content__form-info__empty .baloa-username{\n    color: var(--primary-dark-color);\n}\n\n.modal-confirm-dialog__actions .button:first-of-type {\n    border: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
